<template>
  <div>
    <DataTable :value="invoice.orderRows" :autoLayout="true" >
      <template #header>
        <div class="p-d-flex p-jc-between">
          <div class="p-inputgroup">
            <span class="p-inputgroup-addon" style="color: black">
              Självfaktura
            </span>
            <span class="p-inputgroup-addon">
              <i class="pi pi-id-card"></i>
            </span>
            <span class="p-inputgroup-addon" style="color: black">
              {{invoice.subContractor}}
            </span>
            <span class="p-inputgroup-addon" style="color: black">
              {{id}}
            </span>
            <span class="p-inputgroup-addon" style="color: black">
              {{infoText}}
            </span>
          </div>
          <div class="p-inputgroup">
            <Button label="Skriv ut självfaktura" icon="pi pi-print" :disabled="!printable" @click="printSpec(invoice)" />
          </div>
        </div>
      </template>
      <Column :rowReorder="true" headerStyle="width: 3em" :reorderableColumn="false" />
      <Column field="article" header="Artikel" />
      <Column field="text" header="Text" />
      <Column field="amount" header="Antal" bodyStyle="text-align: right" />
      <Column header="Apris" bodyStyle="text-align: right">
        <template #body="slotProps">
          {{ slotProps.data.price === '' ? '' : slotProps.data.price.toFixed(2) | space1k }}
        </template>
      </Column>
      <Column header="Belopp" bodyStyle="text-align: right">
        <template #body="slotProps">
          {{ slotProps.data.amount === '' ? '' : roundUp(slotProps.data.amount * slotProps.data.price, 2).toFixed(2) | space1k }}
        </template>
      </Column>
      <ColumnGroup type="footer">
        <Row>
          <Column footer="Totalt ex moms:" :colspan="5" footerStyle="text-align: right" />
          <Column :footer="getTotal(invoice.orderRows, 2) | space1k" footerStyle="text-align: right" />
        </Row>
        <Row>
          <Column footer="Moms:" :colspan="5" footerStyle="text-align: right" />
          <Column :footer="roundUp(getTotal(invoice.orderRows) * 0.25, 2).toFixed(2) | space1k" footerStyle="text-align: right" />
        </Row>
        <Row>
          <Column footer="Total:" :colspan="5" footerStyle="text-align: right" />
          <Column :footer="roundUp(getTotal(invoice.orderRows) * 1.25, 2).toFixed(2) | space1k" footerStyle="text-align: right" />
        </Row>
      </ColumnGroup>
    </DataTable>
  </div>
</template>

<script>

import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import ColumnGroup from 'primevue/columngroup'
import Row from 'primevue/row'
import Button from 'primevue/button'
import pdfMake from 'pdfmake'
import vfsFonts from 'pdfmake/build/vfs_fonts'
import moment from 'moment'

import { HagensLogoBase64Mixin } from '@/mixins/HagensLogoBase64Mixin'
import { InvoiceDmtMixin } from '@/mixins/InvoiceDmtMixin'
import { RoundingMixin } from '@/mixins/RoundingMixin'

pdfMake.vfs = vfsFonts.pdfMake.vfs

export default {
  name: 'InvoiceFeralcoCreateSelf',
  mixins: [HagensLogoBase64Mixin, InvoiceDmtMixin, RoundingMixin],
  components: {
    DataTable,
    Column,
    ColumnGroup,
    Row,
    Button
  },
  props: {
    invoice: Object,
    id: String,
    printable: Boolean,
    infoText: String
  },
  computed: {
  },
  mounted () {
  },
  methods: {
    getSpace1k (value) {
      if (value === undefined || value === '') {
        return value
      }
      let [ num, dec ] = this._.split(value, '.', 2)
      if (dec === undefined) {
        dec = '00'
      } else if (dec.length === 1) {
        dec += '0'
      }
      return num.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ') + ',' + dec
    },
    getTotal (rows) {
      return rows === undefined ? 0 : rows.reduce((prev, curr) => curr.tag === 'Separator' ? prev : prev + (this.roundUp(curr.amount * curr.price, 2)), 0).toFixed(2)
    },
    formatForPDF (data) {
      const noBorders = [false, false, false, false]
      const bottomBorders = [false, false, false, true]
      let pdfData = []
      pdfData.push({
        margin: [0, 0, 0, 0],
        layout: 'noBorders',
        fontSize: 10,
        table: {
          headerRows: 1,
          layout: 'noBorders',
          widths: ['*', 'auto', '*', 'auto'],
          body: [
            [
              {text: 'Leveransadress', fontSize: 8, bold: true},
              {text: 'Ert VAT-nummer', fontSize: 8, bold: true},
              {text: 'Kundens adress', fontSize: 8, bold: true},
              {text: '', bold: false}
            ],
            [
              {text: 'Kommunala vatten- &', bold: false},
              {text: 'SE502061893901', bold: false},
              {text: 'Helge R Olsen & Sønn AS', bold: false},
              {text: '', bold: false}
            ],
            [
              {text: 'reningsverk samt pappersbruk', bold: false},
              {text: 'Organisationsnummer', fontSize: 8, bold: true},
              {text: 'Verkstadveien 52', bold: false},
              {text: '', bold: false}
            ],
            [
              {text: 'i södra och mellersta Sverige', bold: false},
              {text: '502061-8939', bold: false},
              {text: '3516 HØNEFOSS', bold: false},
              {text: '', bold: false}
            ],
            [
              {text: '', bold: false},
              {text: '', bold: false},
              {text: 'NORGE', bold: false},
              {text: '', bold: false}
            ],
            [
              {text: '', bold: false},
              {text: '', bold: false},
              {text: '', bold: false},
              {text: '', bold: false}
            ],
            [
              {text: 'Vår referens', fontSize: 8, bold: true},
              {text: 'Leveransperiod', fontSize: 8, bold: true},
              {text: 'Förfallodatum (30 dagar netto)', fontSize: 8, bold: true},
              {text: 'Märkes', fontSize: 8, bold: true}
            ],
            [
              {text: 'Marie Hagén Landegren'},
              {text: data.period},
              {text: moment(data.invoiceDate).add(30, 'days').format('YYYY-MM-DD')},
              {text: data.marking}
            ],
            [
              {text: 'Er referens', fontSize: 8, bold: true},
              {text: 'Aktuell DMT', fontSize: 8, bold: true},
              {text: 'Dröjsmålsränta', fontSize: 8, bold: true},
              {text: 'Leveransvillkor', fontSize: 8, bold: true}
            ],
            [
              {text: 'Kari-Anne Simarud'},
              {text: data.dmt},
              {text: '8%'},
              {text: 'Alltrans 2007, Bulk 20'}
            ]
          ]
        }
      })

      pdfData.push({bold: true, alignment: 'right', fontSize: 10, text: 'S j ä l v f a k t u r e r i n g'})
      pdfData.push({
        margin: [0, 5, 0, 20],
        // layout: 'noBorders',
        fontSize: 9,
        table: {
          headerRows: 1,
          widths: ['auto', '*', 'auto', 'auto', 'auto', 'auto'],
          body: [
            [
              {border: bottomBorders, text: 'Artikel', bold: true},
              {border: bottomBorders, text: 'Benämning', bold: true},
              {alignment: 'right', border: bottomBorders, text: 'Antal', bold: true},
              {alignment: 'right', border: bottomBorders, text: 'Enhet', bold: true},
              {alignment: 'right', border: bottomBorders, text: 'Apris', bold: true},
              {alignment: 'right', border: bottomBorders, text: 'Belopp', bold: true}
            ],
            [
              {border: noBorders, text: ''},
              // {border: noBorders, text: 'TRANSPORT AV EKOFLOCK, VETLANDA -'},
              // {border: noBorders, text: 'TRANSPORT AV KEMIKALIER, SÖLVESBORG -'},
              {border: noBorders, text: this.$props.infoText},
              {border: noBorders, text: ''},
              {border: noBorders, text: ''},
              {border: noBorders, text: ''},
              {border: noBorders, text: ''}
            ],
            ...data.orderRows.map(r => [
              {border: noBorders, text: r.article},
              {border: noBorders, text: r.text},
              {alignment: 'right', border: noBorders, text: this.getSpace1k(r.amount)},
              {alignment: 'right', border: noBorders, text: r.unit},
              {alignment: 'right', border: noBorders, text: this.getSpace1k(r.price)},
              {alignment: 'right', border: noBorders, text: r.tag === 'Separator' ? '' : this.getSpace1k(this.roundUp(r.amount * r.price, 2))}
            ])
          ]
        }
      })
      const totalSum = parseFloat(this.getTotal(data.orderRows))
      const vatSum = parseFloat(this.roundUp(this.getTotal(data.orderRows) * 0.25, 2))
      const totalIncVat = totalSum + vatSum
      const roundingNum = parseFloat(this.roundUp(Math.round(totalSum + vatSum) - totalIncVat, 2))
      const totalAfterRounding = this.roundUp(totalIncVat + roundingNum, 2)
      pdfData.push({
        fontSize: 9,
        unbreakable: true,
        margin: [0, 20, 0, 0],
        columns: [
          [
            {text: data.period + ' ' + data.dmt},
            {text: ' '},
            {text: 'Reklamationer av fakturan ska ske inom'},
            {text: '14 dagar från fakturadatum.'}
          ],
          [
            {
              width: 300,
              table: {
                headerRows: 1,
                layout: 'noBorders',
                widths: ['*', 'auto', '*'],
                body: [
                  [
                    {border: bottomBorders, text: ''},
                    {border: bottomBorders, text: 'Netto'},
                    {alignment: 'right', border: bottomBorders, text: this.getSpace1k(totalSum)}
                  ],
                  [
                    {border: noBorders, text: 'Moms'},
                    {border: noBorders, text: 'Momsunderlag'},
                    {alignment: 'right', border: noBorders, text: 'Moms'}
                  ],
                  [
                    {border: bottomBorders, text: '25%'},
                    {border: bottomBorders, text: this.getSpace1k(totalSum)},
                    {alignment: 'right', border: bottomBorders, text: this.getSpace1k(vatSum)}
                  ],
                  [
                    {border: noBorders, text: ''},
                    {border: noBorders, text: 'Moms kr'},
                    {alignment: 'right', border: noBorders, text: this.getSpace1k(vatSum)}
                  ],
                  [
                    {border: bottomBorders, text: ''},
                    {border: bottomBorders, text: 'Öresavr'},
                    {alignment: 'right', border: bottomBorders, text: this.getSpace1k(roundingNum)}
                  ],
                  [
                    {border: noBorders, colSpan: 2, bold: true, text: 'Vi betalar fakturan till Er på förfallodagen'},
                    {},
                    {alignment: 'right', bold: true, border: noBorders, text: 'SEK ' + this.getSpace1k(totalAfterRounding)}
                  ]
                ]
              }
            }
          ]
        ]
      })
      return pdfData
    },
    printSpec (subInvoice) {
      const headerMargins = [0, 3, 0, 0]
      const noBorders = [false, false, false, false]
      const topBorders = [false, true, false, false]
      const docDefinition = {
        pageMargins: [40, 130, 40, 70],
        header: (currentPage, pageCount) => {
          return {
            fontSize: 10,
            margin: [40, 20, 40, 10],

            columns: [
              {
                width: 150,
                image: this.hagensLogoString
              },
              {
                width: 117,
                text: ''
              },
              [
                {
                  fontSize: 12,
                  columns: [
                    [{ text: 'Självfaktura', bold: true, margin: [0, 0, 0, 0] }],
                    [{ text: this.$props.id, bold: true }],
                    [{ text: currentPage.toString() + '(' + pageCount + ')' }]
                  ]
                },
                {
                  columns: [
                    [{ text: 'Datum', bold: true }, { text: subInvoice.invoiceDate }],
                    [{ text: 'Kund nr', bold: true }, { text: '15778/5397-0612' }],
                    [{}]
                  ],
                  margin: [0, 0, 0, 5]
                }
              ]
            ]
          }
        },
        footer: {
          margin: [40, 10, 40, 10],
          fontSize: 7,
          table: {
            headerRows: 1,
            widths: ['*', '*', '*', '*'],
            body: [
              [
                { border: topBorders, margin: headerMargins, text: 'Postadress', bold: true },
                { border: topBorders, margin: headerMargins, text: 'Kontaktuppgifter', bold: true },
                { border: topBorders, margin: headerMargins, text: 'Företagsuppgifter', bold: true },
                { border: topBorders, margin: headerMargins, text: 'Betalningsuppgifter', bold: true }
              ],
              [
                { border: noBorders, text: 'Hagéns Åkeri AB' },
                { border: noBorders, text: 'Tel: 0383-20600' },
                { border: noBorders, text: 'VAT-nr: SE556203810801' },
                { border: noBorders, text: 'Bankgiro: 615-2052' }
              ],
              [
                { border: noBorders, text: 'Vetlandavägen 45' },
                { border: noBorders, text: 'info@hagens-akeri.com' },
                { border: noBorders, text: 'Godkänd för F-skatt' },
                { border: noBorders, text: '' }
              ],
              [
                { border: noBorders, text: '574 75 KORSBERGA' },
                { border: noBorders, text: 'www.hagens-akeri.com' },
                { border: noBorders, text: 'Företagets säte: Korsberga' },
                { border: noBorders, text: '' }
              ]
            ]
          }
        },
        content: [...this.formatForPDF(subInvoice)]
      }
      pdfMake.createPdf(docDefinition).open()
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Invoices/InvoiceFeralcoCreateSelf.vue